export const gutterBlobal = {
    xs: 0,
    sm: 12,
    xl: 24,
}

export const keysToValidate = [
    'bank_details_verified',
    'personel_info_verified',
    'residency_states_verified',
    'daycare_expenses_verified',
    'rental_income_verified',
    'self_employment_verified',
    'estimated_tax_verified',
    'fbar_fatca_verified',
    'other_income_verified',
    'adjustmenst_income_verified',
    'medical_expenses_verified',
    'taxes_paid_verified',
    'documents_verified',
]